import type { ReactNode } from 'react';

export const symbol_shades_closed: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M463.44-80q-8.96 0-16.7-5Q439-90 435-98q-17-32-47-52t-68-20q-38.97 0-70.48 20Q218-130 201-98q-4.08 8.18-10.54 13.09Q184-80 175-80h-25q-12.75 0-21.37-8.63Q120-97.25 120-110v-710h-11q-12 0-20.5-8.63Q80-837.25 80-850q0-12 8.63-21 8.62-9 21.37-9h740q12 0 21 9t9 21.5q0 12.5-9 21t-21 8.5h-10v710q0 12.75-8.62 21.37Q822.75-80 810-80h-27q-9 0-15.92-5.09Q760.15-90.17 756-98q-16-32-47-52t-69-20q-38.64 0-69.32 20Q540-130 523-98q-4.32 7.83-11.16 12.91Q505-80 496.04-80h-32.6ZM180-168q20-22 47-37t58-20.26V-820H180v652Zm165-59.24Q375-222 401.5-209q26.5 13 48.5 33v-644H345v592.76ZM510-177q20-20 46.5-32.5t57.5-17.74V-820H510v643Zm270 10v-653H674v594.75Q705-220 732-205t48 38ZM285-820H180h105Zm165 0H345h105Zm164 0H510h104Zm166 0H674h106Zm-270 0h-60 60Z"
		/>
	</svg>
);
